// extracted by mini-css-extract-plugin
export default {"form":"ActivityForm_form__jUp7s","formGroup":"ActivityForm_formGroup__ydmCy"};